import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExchangeFareOverride } from 'src/app/core/models/exchange-override.model';

@Component({
  selector: 'app-no-difference-values',
  templateUrl: './no-difference-values.component.html'
})
export class NoDifferenceValuesComponent {
  @Input() exchangeFareOverride: ExchangeFareOverride;
  @Input() isActive: boolean;

  @Output() costMode = new EventEmitter<boolean>();
}
